import { createVanIconComponent } from "./van"

const NewOutlined = createVanIconComponent("new-o")
export default NewOutlined
